export default "__VITE_ASSET__DaZ8CGT2__"